import { ApiProvider } from '@yuno/dashboard-api-mfe'
import styled from '@emotion/styled'
import { useEffect, useMemo, useState } from 'react'
import {
  EmotionThemeProvider,
  ThemeProvider,
  theme,
} from '@yuno/design-system-web'
import { ContainerProvider } from '../yuno-dashboard-container-mfe'
import { InactiveSessionProvider } from '../context/inactive-session-context'
import { useMediaQuery } from '@mui/material'
interface ContainerProps {
  children: React.ReactElement
  loading?: boolean
  content?: boolean
}

const ContentStyled = styled.div<{ open?: boolean; isSmallScreen: boolean }>`
  padding-left: ${({ open, isSmallScreen }) => {
    return isSmallScreen ? 0 : open ? '15.9em' : '76px'
  }};
  height: 89vh;
  background-color: ${theme.palette.grey[0]};
`

export const Content = ({ children, open, containerError = false }) => {
  const [error, setError] = useState(0)
  const matches = useMediaQuery('(max-width: 1023px)')

  useEffect(() => {
    addEventListener('beforeunload', () => {
      localStorage.removeItem('ERROR_NAV')
    })

    addEventListener('storage', (evt: StorageEvent) => {
      if (evt.key === 'ERROR_NAV') {
        setError(Number(evt.newValue))
      }
    })

    return () => {
      localStorage.removeItem('ERROR_NAV')
    }
  }, [])
  if (error && !containerError) return null

  return (
    <ContentStyled isSmallScreen={matches} open={matches ? false : open}>
      {children}
    </ContentStyled>
  )
}

export function Container({ children }: ContainerProps) {
  const matches = useMediaQuery('(max-width: 1023px)')
  const initialDrawerState =
    useMemo(() => localStorage.getItem('DRAWER'), []) === 'opened' && !matches
  const [openDrawer, setOpenDrawer] = useState(initialDrawerState)
  useEffect(() => {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'DRAWER') {
        setOpenDrawer(event.newValue === 'opened')
      }
    })
  }, [])

  return (
    <EmotionThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <InactiveSessionProvider>
          <ApiProvider>
            <ContainerProvider>
              <Content open={openDrawer}>{children}</Content>
            </ContainerProvider>
          </ApiProvider>
        </InactiveSessionProvider>
      </ThemeProvider>
    </EmotionThemeProvider>
  )
}
